import { render, staticRenderFns } from "./rowOnly.vue?vue&type=template&id=4074b739&scoped=true"
import script from "./rowOnly.vue?vue&type=script&lang=js"
export * from "./rowOnly.vue?vue&type=script&lang=js"
import style0 from "./rowOnly.vue?vue&type=style&index=0&id=4074b739&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4074b739",
  null
  
)

export default component.exports